import { Phone, Clock, Mail, Instagram } from "lucide-react";
import { siteConfig } from "@/lib/site-config";

const TopBar = () => {
  return (
    <div className="hidden sm:block bg-accent text-accent-foreground">
      <div className="container-max flex flex-col sm:flex-row items-center justify-between px-4 py-2 text-xs sm:text-sm gap-1 sm:gap-0">
        <div className="flex items-center gap-4">
          <a href={siteConfig.emailHref} className="flex items-center gap-2 hover:text-primary transition-colors">
            <Mail className="h-3.5 w-3.5 text-primary" />
            <span className="hidden md:inline">{siteConfig.email}</span>
            <span className="md:hidden">Email Us</span>
          </a>
          <div className="hidden md:flex items-center gap-2">
            <Clock className="h-3.5 w-3.5 text-primary" />
            <span>{siteConfig.hours.summary} · Closed {siteConfig.hours.closed}</span>
          </div>
        </div>
        <div className="flex items-center gap-4">
          {siteConfig.social.instagram && (
            <a
              href={siteConfig.social.instagram}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`${siteConfig.name} on Instagram`}
              className="hover:text-primary transition-colors"
            >
              <Instagram className="h-3.5 w-3.5" />
            </a>
          )}
          <a href={siteConfig.phoneHref} className="flex items-center gap-2 hover:text-primary transition-colors font-semibold">
            <Phone className="h-3.5 w-3.5 text-primary" />
            <span>{siteConfig.phone}</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
